import React, { useState } from 'react'
/* components */
import { Box } from '@mui/material'
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined'
/* styles */
import useStyles from './useStyles'
import SearchField from '../../SearchField/SearchField'

function SearchMobile () {
  const [show, setShow] = useState(true)
  const classes = useStyles()
  const handleToggle = () => {
    setShow(!show)
  }
  return (
    <Box className={classes.searchContainer}>
      {show
        ? (
        <SearchField cerrarFn={handleToggle} />
          )
        : (
        <Box className={classes.containerIcon}>
          <SearchOutlinedIcon className={classes.icon} onClick={handleToggle} />
        </Box>
          )}
    </Box>
  )
}

export default SearchMobile
